<template>
    <div class="c2-task-main" v-if="bodyShow">
        <h2>{{title}}</h2>
        <public-dialogue v-if="data.testid&&data.testid != 0" :testid="data.testid" :cid="$route.query.cid" :taskid="$route.query.id"></public-dialogue>
        <!--  -->
        <div v-for="(item,index) in list" :key="index">
            <!-- title -->
            <div v-if="item.type == 'title'" :class="['c2-task-group',(item.type == 'title'&& item.config)?'-mt':'',index==0?'title_one':'']">
                <!-- 处理字体颜色  -----参数:标题、需要变色的文字、颜色值、说明 -->
                 <h3  v-html="doFontColor(item)"></h3>
            </div>
            <!-- text -->
            <div v-if="item.type=='text'" class="c2-task-group text">
                 <h3  v-html="doFontColor(item)"></h3>
                <div class="task-group-text">
                    <textarea class="c2-textarea" @input="textareaChange(index,item)" v-model="item.content" :placeholder="item.config.placeholder" ></textarea>
                    <span class="c2-word-limit">{{item.content?item.content.length:0}}/{{item.config.word}}</span>
                </div>
            </div>
            <!-- subtitle -->
            <div v-if="item.type=='subtitle'" class="c2-task-group subtitle">
                <small class="small subtitle" v-html="doFontColor(item)"></small>
            </div>
            <!-- textarea -->
            <div v-if="item.type == 'textarea'" class="c2-task-group">
                <h3  v-html="doFontColor(item)"></h3>
                <div class="task-group-text">
                    <textarea class="c2-textarea" @input="textareaChange(index,item)" v-model="item.content" :placeholder="item.config.placeholder" ></textarea>
                    <span class="c2-word-limit">{{item.content?item.content.length:0}}/{{item.config.word}}</span>
                </div>
                <small class="small" v-if="item.config.subtitle"><span>*</span>{{item.config.subtitle.text}}</small>
            </div>
            <!-- add -->
            <div v-if="item.type=='add'" class="c2-group">
                <!-- add -->
                <div v-if="action_array.length==0" class="add">
                    <img  @click="addActionHandle(item)" src="@a/c2-add.png" alt="">
                    <span v-if="action_array.length==0" class="small subtitle" v-html="doFontColor(item)"></span>
                    <span v-else class="small subtitle" >添加当前行动</span>
                </div>
                <!-- text -->
                <div v-else>
                    <div v-for="(item2,index2) in action_array" :key="index2">
                        <div  class="c2-task-group text">
                            <h3  v-html="doFontColor(item2)"></h3>
                            <div class="task-group-text">
                                <textarea class="c2-textarea" @input="textareaChange(index2,item,'action_array',index2,item2)" v-model="item2.content" :placeholder="item2.config.placeholder" ></textarea>
                                <span class="c2-word-limit">{{item2.content?item2.content.length:0}}/{{item2.config.word}}</span>
                            </div>
                        </div>
                        <!--  -->
                        <div class="c2-group" >
                            <!-- add -->
                            <div v-if="action_array.length<action_item.config.num" class="add">
                                <img  @click="addActionHandle(action_item)" src="@a/c2-add.png" alt="">
                                <span v-if="action_array.length==0" class="small subtitle" v-html="doFontColor(item2)"></span>
                                <span v-else class="small subtitle" >添加当前行动</span>
                            </div>
                            <!--  -->
                            <div  class="add">
                                <img @click="doRemoveHandle(index2)" src="@a/c2-remove.png" alt="">
                                <span class="small subtitle">删除当前行动</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- 引入项目攻略入口 -->
        <task-strategy :cid="$route.query.cid" :pid="$route.query.pid"></task-strategy>
        <!-- submit -->
        <button :class="['c-submit',bool?'on':'']" @click="submithandle">提交</button>
        <!-- 弹出内容2 -->
		<van-popup class="explain" v-model="explain">
			<div>
				<h2>{{explain_difficult.title}}</h2>
				<p class="pps" v-html="explain_difficult.content"></p>
			</div>
		</van-popup>

        <!-- 删除弹窗 -->
        <van-popup class="pub_alert" v-model="deletePopup">
            <div class="confirm_box">
                <h2>是否确认删除？</h2>
                <div class="btn_group">
                    <a class="confirm on" href="javascript:;" @click="removeActionHandle">确认</a>
                    <a class="cancel" href="javascript:;" @click="deletePopup=false">取消</a>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { index, subtable } from "@/api/course"
import { taskGlossary } from "@/api/course2"
import { getStorage, setStorage,deepCopy } from "@/utils/tools"
import { shareCon } from "@/utils/wxconfig"
import TaskStrategy from "@c/course/task-strategy"
export default {
    data() {
        return{
            bodyShow:false,
            title:'',
            list:[],
            userfield:[],
            bool:true,
            word_num:0,
            difficult:[],
            explain:false,
            // 难词
            explain_difficult:{
                title:'',
                content:''
            },
            difficult_text:'',
            // 行动
            action_array:[],
            // 从第几个开始
            begin_num:0,
            // 存储需要添加类型
            action_item:{},
            deletePopup:false,
            action_index:null,
            data:{},
        }
    },
    components:{
        TaskStrategy
    },
    mounted(){
        window.difficultHandle = this.difficultHandle;
    },
    methods:{
        doRemoveHandle(index){
            this.deletePopup = true;
            this.action_index = index;
        },
        // 删除行动
        removeActionHandle(){
            this.$delete(this.action_array,this.action_index);
            this.begin_num-=1;
            let num = this.begin_num<6?this.begin_num-1:this.begin_num-2;
            for(let i = this.action_index;i<this.action_array.length;i++){
                this.action_array[i].config.typeSet.text = this.action_array[i].config.typeSet.text.split(/[0-9]+/)[0]+(num+i);
                this.action_array[i].label = this.action_array[i].label.split(/[0-9]+/)[0]+(num+i);
            }

            this.deletePopup = false;
            // 调用验证方法
            this.validationHandle();
        },
        // 添加行动
        addActionHandle(item,bl){
            if(Object.keys(item).length>0){
                this.action_item = {...item};
            }
            if(this.begin_num==0){
                this.begin_num = item.config.startnum;
            }
            if(this.action_array.length<=item.config.num){
                for(let i=0;i<this.list.length;i++){
                    // 正则去数字之前的标题
                    if((this.list[i].type=='text' || this.list[i].type=='textarea') && item.config.title && this.list[i].label.indexOf(item.config.title.text.split(/[0-9]+/)[0])>-1){
                        let obj = deepCopy(this.list[i]);
                        obj.sort = item.sort+=1;
                        obj.label = item.config.title.text.split(/[0-9]+/)[0]+this.begin_num;
                        obj.id = item.id;
                        obj.content= bl?item.content:"";
                        obj.config.placeholder=item.config.placeholder;
                        // 加上从第几个开始，统一改变字体颜色
                        let typeSet_ = deepCopy(item.config.title.typeSet);
                        typeSet_.text+=this.begin_num;
                        obj.config.typeSet = deepCopy(typeSet_);
                        obj.config.word = item.config.word
                        this.action_array.push(obj);
                        if(this.begin_num<=6){
                            this.begin_num+=1;
                        }
                        // 调用验证方法
                        this.validationHandle();
                        break;
                    }
                }
            }
        },
        // 转base64
        b64Encode(str) {
            return window.btoa(encodeURIComponent(str));
        },
        b64Decode(str) {
            return decodeURIComponent(window.atob(str));
        },
        difficultHandle(text){
            if(!text) {
                return;
            }
            this.difficult.forEach((item,index)=>{
                if(item.name==this.b64Decode(text)){
                    console.log(item.name,this.b64Decode(text));
                    this.explain_difficult.title =item.name;
                    // 替换空格和换行
                    this.explain_difficult.content =item.explain.replace(/\n/g,"<br/>").replace(/ /g,"&nbsp;");
                }
            });
            this.explain = true;
        },
        // 改变字体颜色
        doFontColor(item){
            let font = item.label;
            let typeSet = item.config.typeSet?item.config.typeSet:'';
            let subtitle = item.config.subtitle?item.config.subtitle:'';
            let difficult_text = '';

            if(item.type=='subtitle' && item.config){
                difficult_text = item.config.difficult?item.config.difficult[Object.keys(item.config.difficult)[0]].text:'';
            }

            // small是括号里的说明
            if(typeSet.text instanceof Array) {
                typeSet.text.forEach((item,idx)=>{
                    font = font.replace(item,(v)=>{
                        return "<span onclick=\"difficultHandle('"+this.b64Encode(difficult_text)+"')\">"+ v.fontcolor(typeSet.color) +"</span>"
                    })+((subtitle && subtitle.position!='bottom')?"<span class='small'>"+subtitle.text+"</span>":'');
                });
                return font;
            } else {
                return font.replace(typeSet.text,(v)=>{
                    return "<span onclick=\"difficultHandle('"+this.b64Encode(difficult_text)+"')\">"+ v.fontcolor(typeSet.color) +"</span>"
                })+((subtitle && subtitle.position!='bottom')?"<span class='small'>"+subtitle.text+"</span>":'');
            }
        },
        //改变输入框时触发------- 下标、内容、id、字数长度
        // textareaChange(index,content,id,word,val){
        //     this.$forceUpdate();
        //     if(content && content.length > word) {
        //         if(val && val==='action_array'){
        //             this.$set(this.action_array[index],'content',content.slice(0, word));
        //         }else{
        //             this.$set(this.list[index],'content',content.slice(0, word));
        //         }
		//         this.$toast(`最多只能输入${word}个字。/(ㄒoㄒ)/~~`);
		//     }else{
		//     	setStorage(this.$route.path, 'id'+id, content);
        //     }
        //     this.validationHandle();
        // },
        /*
         *@param: index 下标、item 改变值的对象、type 类型、num 动态添加兴趣的第几个、actionitem 动态改变添加兴趣值的对象
         *@return:
         *@Description: 改变输入框时触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-17 10:59:14
        */
        textareaChange(index,item,type,num,actionitem){
            this.$forceUpdate();
            // 判断是否是添加兴趣爱好
            if(type && type==='action_array'){
                if(actionitem.content && actionitem.content.length > item.config.word) {
                    this.$set(this.action_array[index],'content',actionitem.content.slice(0, item.config.word));
                    this.$toast(`最多只能输入${item.config.word}个字。/(ㄒoㄒ)/~~`);
                }else{
                    let arr = deepCopy(actionitem);
                    this.$delete(arr,'config');
                    this.$set(arr, 'config',item.config)
                    setStorage(this.$route.path, 'action_array'+num, arr);
                }
            }else{
                if(item.content && item.content.length > item.config.word) {
                    this.$set(this.list[index],'content',item.content.slice(0, item.config.word));
                    this.$toast(`最多只能输入${item.config.word}个字。/(ㄒoㄒ)/~~`);
                }else{
                    setStorage(this.$route.path, 'id'+item.id, item.content);
                }
            }
            this.validationHandle();
        },
        getDifficultHandle(){
             // 获取难词
            taskGlossary({
                course_id:this.$route.query.cid,
                project_id: this.$route.query.pid,
                task_id: this.$route.query.id
            }).then((data)=>{
                if(data.code===10002){
                    this.$toast(data.data.msg);
                    return
                }
                // 取出难词difficult
                this.list.forEach((item,index)=>{
                    if(item.type=='subtitle' && item.config.difficult){
                        this.$forceUpdate();
                        let nc = item.config.difficult[Object.keys(item.config.difficult)[0]];
                        if(data.list && data.list.length>0){
                            data.list.forEach((item2,index2)=>{
                                if(item.config && nc.text==item2.word_name){
                                    this.difficult.push({
                                        name:item2.word_name,
                                        explain:item2.word_explain
                                    });
                                }
                            });
                        }
                    }


                });
            });
        },
        pullData(){
            // loading
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            // 获取页面初始化数据
            index({
                cid: this.$route.query.cid,
                cpid: this.$route.query.pid,
                cptid: this.$route.query.id
            }).then((data)=>{
            this.$toast.clear();
            if(data.code===10002){
                this.$toast(data.data.msg);
                return
            }
                this.list = data.field;
                this.userfield = data.userfield;
                document.title = this.$route.query.name;
                this.title = data.title;
                this.data = data;
                this.validationHandle(true);
                this.getDifficultHandle();
                this.bodyShow = true;
            });
        },
        validationHandle(bl){
            let b = true;
            if(this.list && this.list.length==0){
                this.bool = false;
                return
            }
            this.list.forEach((item,index)=>{
                // 判断是否是初始化
                if(bl){
                     // 判断是否已提交过数据
                    if(this.userfield && this.userfield.length>0){
                        this.userfield.forEach((item2,key)=>{
                            if(this.list[index].content){
                                return
                            }
                            if(item2.content && item2.field_id == item.id){
                                if(item.type=='add'){
                                    item2.content.split('|').forEach((action_item,index)=>{
                                        let obj_ = {...item};
                                        obj_['content'] = action_item;
                                        this.addActionHandle(obj_,bl);
                                    });
                                }else{
                                    this.list[index].content = item2.content;
                                }

                            }
                        });
                        
                    }else{
                        // 判断是否是动态添加的兴趣爱好
                        if(getStorage(this.$route.path, 'action_array'+index)){
                            let o =deepCopy(getStorage(this.$route.path, 'action_array'+index));
                            this.addActionHandle(o,bl);
                        }
                        this.list[index].content = this.list[index].content?this.list[index].content:getStorage(this.$route.path, 'id'+item.id) || '';
                    }
                    if(!this.list[index].content) {
                        this.list[index].content = '';
                    }
                }
                // 判读是否有空
                if((this.list[index].type=='text' || this.list[index].type=='textarea')&&(!this.list[index].content || this.list[index].content=='')){
                    b =false;
                }
            });

            // 判断新增的是否有空
            this.action_array.forEach((item,index)=>{
                // 判读是否有空
                if((this.action_array[index].type=='text' || this.action_array[index].type=='textarea')&&(!this.action_array[index].content || this.action_array[index].content=='')){
                   b =false;
                }
            });
            this.bool = b;
        },
        submithandle(){
            if(this.bool){
                let arr = [];
                this.list.forEach((item,index)=>{
                    if(item.content){
                        arr.push({
                            field_id:item.id,
                            content:item.content
                        });
                    }
                });
                //
                if(this.action_array.length>0){
                    let content = '',ids=null;
                    this.action_array.forEach((item2,index)=>{
                        ids = item2.id;
                        content+=item2.content+((index+1)==this.action_array.length?'':'|');
                    });
                    arr.push({
                        field_id:ids,
                        content:content
                    });
                }
                subtable({
                    cid:this.$route.query.cid,
                    form_id:this.list[0].form_id,//引入form_id都是一样的，所以取一个就可以
                    field:JSON.stringify(arr)
                }).then((data)=>{
                    this.$toast({
                        duration: 1000,
                        message: '提交成功！',
                        onClose:()=>{
                            this.$router.push({
                                path:'/project_report',
                                query:{
                                    cid:this.$route.query.cid,
                                    cpid:this.$route.query.pid,
                                    taskid: this.$route.query.id
                                }
                            });
                        }
                    });
                });
            }
        }
    },
    created(){
        this.pullData();
        shareCon("course2",this);
    }
}
</script>

<style lang="scss" scope>
    .c2-task-main{
        padding: 40px 30px 80px;
        text-align: center;
        h2{
            font-weight: bold;
            font-size: 36px;
            color: #333333;
            text-align: center;
        }
        .c2-task-group{
            margin-top: 30px;
            position: relative;
            text-align: left;
            .task-group-text{
                position: relative;
            }

            h3{
                text-align: left;
                font-size: 32px;
                color: #333333;
            }
            .c2-textarea{
                margin-top: 20px;
                height: 160px;
                border-radius: 8px;
                background-color: #fff;
                border: 0;
                width: 100%;
                padding: 22px 20px;
                font-size: 26px;
                resize:none;
                text-align: left;
            }
            .c2-word-limit{
                position: absolute;
                font-size: 18px;
                color: #999;
                bottom: 14px;
                right: 16px;
            }
            small.small{
                font-size:24px;
                color: #666666;
                span{
                    color: #EA345C;
                    margin-right: 5px;
                }
            }
            small.small.subtitle font{
                text-decoration: underline;
            }
        }
        .c2-task-group.-mt{
            margin-top: 50px;
        }
        .c2-group{
            font-size: 0;
            text-align: left;
            .add{
                margin-top: 10px;
                margin-right: 40px;
                display: inline-block;
                img{
                    width: 36px;
                    height: 36px;
                    margin-right: 10px;
                    vertical-align: top;
                }
                .small{
                    font-size:24px;
                    color: #666666;
                    span{
                        // color: #EA345C;
                        margin-right: 5px;
                    }
                }
            }
        }
        .c2-task-group.title_one,.c2-task-group.-mt.title_one{
            margin-top: 40px;
        }
        .c2-task-group.subtitle{
            margin-top: 20px;
        }
        .c2-task-group.text{
            margin-top: 30px;
            h3{
                color: #333333;
                line-height: 1;
            }
            .task-group-text{
                position: relative;
            }
            .c2-textarea{
                margin-top: 20px;
                height: 70px;
                line-height: 70px;
                padding: 0px 20px;
            }
            .c2-radio-group{
                margin-top: 14px;
                font-size: 0;
                .van-radio__icon{
                    display: none;
                }
                .van-radio__label{
                    text-align: center;
                    vertical-align: unset;
                    line-height: 70px;
                    margin-left: auto;
                    color: #EA345C;
                    width: 100%;
                }
                .radio-btn{
                    padding: 0;
                    width:156px;
                    height:70px;
                    line-height: 70px;
                    font-size: 26px;
                    border:2px solid #EA345C;
                    border-radius:8px;
                    color: #EA345C;
                    margin-right: 20px;
                    display: inline-block;
                    background-color: #fff;
                }
                .radio-btn.active .van-radio__label{
                    background-color: #EA345C;
                    color: #fff;
                }
                .radio-btn:last-child{
                    margin-right: 0px;
                }
            }
        }
        .c2-task-group.holland {
            margin-top: 28px;
            h3{
                font-size: 28px;
                color: #333333;
                line-height: 1;
            }
        }
        .c-submit{
            width:174px;
            height:66px;
            background:#CCCCCC;
            border-radius:33px;
            font-size: 34px;
            color: #FFFFFF;
            border: 0;
            margin: 80px auto auto;
        }
        .c-submit.on{
            background-color: #EA345C;
        }
        /* 弹窗 */
        .explain{
            width: 690px;
            padding: 40px 50px;
            border-radius:9px;
            text-align: left;
            h2{
                text-align: left;
                margin-top: 0;
                font-size: 32px;
                color: #EA345C;
                font-weight: normal;
                margin-bottom: 24px;
            }
            .pps{
                font-size: 26px;
                line-height:48px;
                color: #333;
                text-align: justify;
            }
        }
    }
</style>